import React, { Fragment, useState } from 'react';

import {
  OuterContainer,
  FlexContainer,
  ContainerHeading,
  RecruitmentStagesContainer,
  IntegrationFieldLabel,
  TextInput,
  ErrorMessage,
  LabelAndCheckboxContainer,
  ProficiencyContainer,
  ProficiencySubContainer,
  SeparationLine,
} from './styles';
import { Button } from 'components/Button/RoundButton';

export default React.memo(({ candidateRatingAreas, updateCandidateRatingAreas, id, isSuperadmin }) => {
  const [candidateRatings, setCandidateRatings] = useState(candidateRatingAreas || []);
  const [formError, setFormError] = useState('');

  const addRatingArea = () => {
    let copyOfCandidateRatings = JSON.parse(JSON.stringify(candidateRatings));
    copyOfCandidateRatings.push({
      name: '',
      valueTexts: ['Very Low', 'Low', 'Average', 'Good', 'Very Good', 'Excellent'],
    });
    setCandidateRatings(copyOfCandidateRatings);
  };

  const removeRatingArea = (index) => {
    let copyOfCandidateRatings = JSON.parse(JSON.stringify(candidateRatings));
    copyOfCandidateRatings.splice(index, 1);
    setCandidateRatings(copyOfCandidateRatings);
  };

  const updateRating = (value, outerIndex, innerIndex) => {
    let copyOfCandidateRatings = JSON.parse(JSON.stringify(candidateRatings));
    if (innerIndex >= 0) copyOfCandidateRatings[outerIndex]['valueTexts'][innerIndex] = value.trim();
    else copyOfCandidateRatings[outerIndex]['name'] = value.trim();
    setCandidateRatings(copyOfCandidateRatings);
  };

  const saveRatings = () => {
    let hasBlank = false;
    for (const candidateRating of candidateRatings) {
      if (candidateRating.name === '') hasBlank = true;
      if (candidateRating.valueTexts.includes('')) hasBlank = true;
    }
    if (hasBlank) return setFormError('Values cannot be blank');
    else setFormError('');
    if (isSuperadmin) updateCandidateRatingAreas(id, { value: candidateRatings });
    else updateCandidateRatingAreas(id, { candidateRatings });
  };

  const renderRatingAreas = () => {
    return candidateRatings.map((rating, outerIndex) => {
      return (
        <Fragment key={outerIndex}>
          <IntegrationFieldLabel margin="15px 0 0 0">Skill Name</IntegrationFieldLabel>
          <LabelAndCheckboxContainer>
            <TextInput
              type="text"
              isEditing={true}
              padding="5px 5px 0 5px"
              height="30px"
              margin="0"
              width="50%"
              fullWidthOnMobile={true}
              onChange={(e) => updateRating(e.target.value, outerIndex)}
              value={rating.name}
            />
            <Button
              small
              primaryRed
              padding="5px 9px 5px 10px"
              margin="0 0 0 6px"
              onClick={() => removeRatingArea(outerIndex)}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </Button>
          </LabelAndCheckboxContainer>
          <ProficiencyContainer>
            {rating.valueTexts.map((value, innerIndex) => {
              return (
                <ProficiencySubContainer key={innerIndex}>
                  <IntegrationFieldLabel margin="15px 0 0 0">Proficiency {innerIndex + 1}</IntegrationFieldLabel>
                  <TextInput
                    type="text"
                    isEditing={true}
                    fullWidthOnMobile
                    height="33px"
                    width="100%"
                    margin="5px 0 0 0"
                    value={value}
                    onChange={(e) => updateRating(e.target.value, outerIndex, innerIndex)}
                  />
                </ProficiencySubContainer>
              );
            })}
          </ProficiencyContainer>
          {outerIndex + 1 !== candidateRatings.length && <SeparationLine />}
        </Fragment>
      );
    });
  };

  return (
    <OuterContainer>
      <ContainerHeading>Candidate Rating Areas</ContainerHeading>
      <RecruitmentStagesContainer>
        {renderRatingAreas()}
        {formError && <ErrorMessage padding="15px 0 0 0">{formError}</ErrorMessage>}
        <FlexContainer>
          <Button small primaryBlue primaryGreenBorder removeMargin margin="15px 0 0 0" onClick={() => addRatingArea()}>
            Add
          </Button>
          <Button
            small
            primaryBlue
            primaryGreenBorder
            removeMargin
            margin="15px 0 0 10px"
            onClick={() => saveRatings()}
          >
            Save
          </Button>
        </FlexContainer>
      </RecruitmentStagesContainer>
    </OuterContainer>
  );
});
